import React, { useEffect, useState } from 'react';
import { DatePicker, Select } from 'antd';
import { ToastError, ToastSuccess } from 'components/Toaster';
import { SolucoesPerfilUsuarioService } from 'core/http/service/SolucoesPerfilUsuario.service';
import { TipoSolucoesService } from 'core/http/service/TipoSolucoes.service';
import dayjs from 'dayjs';
import Colors from 'enums/Colors';
import TipoSolucoes from 'models/solucoes/TipoSolucoes';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import { IoReload } from 'react-icons/io5';
import styled from 'styled-components';
import { FadCoursesService } from 'core/http/service/ferramentaAutoria/FadCourses.service';
import { FadCoursesModel } from 'models/ferramentaAutoria/FadCoursesModel';
import { ComponentInteractionService } from 'core/http/service/componetInteraction/ComponentInteraction.service';

export interface ParmsReport {
    dateInicio?: string | null;
    dateFim?: string | null;
}

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1100px;
        min-height: 320px;
        background-color: #ffffff;
        padding: 40px;
        gap: 2rem;
        margin-bottom: 200px;

        -webkit-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        -moz-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
    `,

    Title: styled.h1`
        font-size: 26px;
        font-weight: 700;
        color: ${Colors.Blue};
        text-decoration: underline;
        text-underline-offset: calc(1rem);
    `,

    Content: styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 1rem;
        gap: 2rem;
        margin-top: 30px;
    `,

    SubTitle: styled.p`
        font-size: 14px;
        font-weight: 600;
        color: ${Colors.Blue};
        margin-bottom: 10px;
    `,
};

interface ICardReportQuizzes {}

const serviceFerramentaAutoria = new FadCoursesService();
const serviceComponentInteraction = new ComponentInteractionService();

export interface ReportBody {
    codigo: number;
    idsQuizzes: number[];
}

const CardReportQuizzes = ({}: ICardReportQuizzes) => {
    const [loadingSubmit, setLoadingSubmit] = useState<number>(-1);
    const [courses, setCourses] = useState<FadCoursesModel[]>([]);
    const [courseSelected, setCourseSelected] = useState<any>(null);
    const [quizzes, setQuizzes] = useState<any>();
    const [selectedQuizzes, setSelectedQuizzes] = useState<any[]>([]);
    const [dataPeriodo, setDataPeriodo] = useState<string[]>([]);

    function cleanParams(params: Record<string, any>) {
        return Object.fromEntries(
            Object.entries(params).filter(([_, value]) => {
                return value !== undefined && value !== null && value !== '';
            })
        );
    }

    const handleRelatorioFad = async () => {
        if (!selectedQuizzes.length) {
            return ToastError('Nenhum quiz selecionado!');
        }

        setLoadingSubmit(1);

        try {
            const rawBody: ParmsReport = {
                dateInicio: dataPeriodo.length > 0 ? dataPeriodo[0] : null,
                dateFim: dataPeriodo.length > 0 ? dataPeriodo[1] : null,
            };

            const params = cleanParams(rawBody);

            const body: ReportBody = {
                codigo: courseSelected,
                idsQuizzes: selectedQuizzes,
            };

            const response = await serviceComponentInteraction.relatorioQuizzes(body, params);

            if (response && response.status === 200) {
                ToastSuccess('Relatório sendo gerado com sucesso!');
            }
        } catch (error) {
            ToastError('Ocorreu algum erro no servidor!');
        }
        setLoadingSubmit(-1);
    };

    const getAllCourses = async () => {
        const { data, status } = await serviceFerramentaAutoria.findAllFadCourses();

        if (status === 200) {
            setCourses(data);
        }
    };

    const clearFilter = () => {
        setDataPeriodo([]);
        setCourseSelected(null);
        setQuizzes([]);
        setSelectedQuizzes([]);
    };
    
    useEffect(() => {
        getAllCourses();
    }, []);

    return (
        <Styled.Container>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Styled.Title>RELATÓRIO QUIZZES</Styled.Title>
                <div
                    onClick={clearFilter}
                    style={{
                        display: 'flex',
                        gap: '0.5rem',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                >
                    <IoReload size={24} />
                    Limpar filtro
                </div>
            </div>
            <Styled.Content>
                <div>
                    <Styled.SubTitle>Curso Ferramenta de Autoria</Styled.SubTitle>
                    <Select
                        style={{ width: '200px', height: '50px' }}
                        placeholder="Selecione"
                        value={courseSelected}
                        onChange={(s: any) => setCourseSelected(s)}
                        options={courses.map((dados: any) => ({
                            value: dados.codigo,
                            label: dados.codigo + ' - ' + dados.name,
                        }))}
                    />
                </div>
              

                <div>
                    <Styled.SubTitle>Período</Styled.SubTitle>
                    <DatePicker.RangePicker
                        size="large"
                        style={{
                            height: 50,
                        }}
                        value={dataPeriodo.length === 2 ? [dayjs(dataPeriodo[0]), dayjs(dataPeriodo[1])] : null}
                        placeholder={['Início', 'Término']}
                        allowEmpty={[false, false]}
                        onChange={(date, dateString) => {
                            setDataPeriodo(dateString);
                        }}
                    />
                </div>
            </Styled.Content>
            <Styled.Content style={{gridTemplateColumns: "1fr"}}>
                  <div>
                    <Styled.SubTitle>Quizzes</Styled.SubTitle>
                    <Select
                        mode="multiple"
                        size='large'
                        style={{ width: '100%', height: selectedQuizzes.length > 1 ? 'auto' : '50px' }}
                        placeholder="Selecione"
                        disabled={!courseSelected}
                        loading={!quizzes && courseSelected}
                        onFocus={async () => {
                            if (courseSelected) {
                                const { data } = await serviceFerramentaAutoria.findQuizzesByCourse(courseSelected);
                                setQuizzes(data);
                            }
                        }}
                        value={Array.from(selectedQuizzes)}
                        onChange={(s: any) => setSelectedQuizzes(s)}
                        options={quizzes?.map((dados: any) => ({
                            value: dados.id,
                            label: (() => {
                                const clean = dados.pergunta.replace(/<[^>]*>/g, '');
                                return clean.length > 80 ? clean.slice(0, 80) + '...' : clean;
                            })(),
                        }))}
                    />
                </div>
            </Styled.Content>
            <ButtonHomeV2
                disabled={loadingSubmit === 1}
                style={{ color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => {
                    loadingSubmit === -1 && handleRelatorioFad();
                }}
            >
                {loadingSubmit === 1 ? <div className="loaderCreater" /> : 'Gerar relatório'}
            </ButtonHomeV2>
        </Styled.Container>
    );
};

export default CardReportQuizzes;
